import React from 'react';
import { ArrowLeft, User } from 'lucide-react';

/**
 * Shared sticky navbar used on all public-facing pages.
 *
 * Props:
 *   onBack   — if provided, renders a back arrow on the left
 *   onLogin  — if provided, renders a user icon on the right
 */
const LandingNavbar = ({ onBack, onLogin }) => (
  <nav
    className="flex items-center justify-between px-6"
    style={{
      position:           'sticky',
      top:                0,
      zIndex:             50,
      height:             48,
      background:         'rgba(255,255,255,0.82)',
      backdropFilter:     'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderBottom:       '1px solid rgba(0,0,0,0.06)',
    }}
  >
    {/* Left slot */}
    {onBack ? (
      <button
        onClick={onBack}
        className="p-2 rounded-full transition-colors hover:bg-black/5 active:scale-90"
        aria-label="Volver"
      >
        <ArrowLeft size={20} strokeWidth={1.8} />
      </button>
    ) : (
      <div className="w-9" />
    )}

    {/* Wordmark */}
    <span
      className="text-[12px] font-semibold uppercase tracking-[0.14em] text-black select-none"
    >
      VONDI
    </span>

    {/* Right slot */}
    {onLogin ? (
      <button
        onClick={onLogin}
        className="p-2 rounded-full transition-colors hover:bg-black/5 active:scale-90"
        aria-label="Acceder"
      >
        <User size={20} strokeWidth={1.8} />
      </button>
    ) : (
      <div className="w-9" />
    )}
  </nav>
);

export default LandingNavbar;
